import { render } from "./PNAEC.vue?vue&type=template&id=7c9975bc&scoped=true"
import script from "./PNAEC.vue?vue&type=script&lang=js"
export * from "./PNAEC.vue?vue&type=script&lang=js"

import "./PNAEC.vue?vue&type=style&index=0&id=7c9975bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9975bc"]])

export default __exports__